import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'
import scrollTo from '../utils/helpers/scrollTo'

class Nav {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.nav = document.querySelector('.nav');
      cache.navmobileBtn = document.querySelector('.nav_mobile');
      cache.alert = document.querySelector('.alert');
      cache.scrollNxt = document.querySelectorAll('.scroll-nxt');
      cache.scrollLinks = document.querySelectorAll('.scroll-to');
      cache.nav_links = cache.nav.querySelectorAll('a');

      if(cache.alert){
        cache.alert.style.display = "flex";
        const height = cache.alert.offsetHeight;
        cache.alert.style.height = 0;
        anime({
          targets: cache.alert,
          height: [0,height],
          duration: 500,
          delay: 600,
          easing: 'easeOutSine'
        });
        anime({
          targets: document.body,
          paddingTop: [0,height],
          duration: 500,
          delay: 600,
          easing: 'easeOutSine'
        });
      }
    }; 

    let registerEvents = () => {
      cache.navmobileBtn.addEventListener("click", openNav);
      if(cache.alert){
        cache.alert.querySelector('.close-alert').addEventListener("click", closeAlert);
      }
      for (let i = 0; i < cache.scrollNxt.length; i++) {
        cache.scrollNxt[i].addEventListener("click", scrollToNextSection);
      }
      for (let i = 0; i < cache.scrollLinks.length; i++) {
        cache.scrollLinks[i].addEventListener("click", scrollToSection);
      }
      for (let i = 0; i < cache.nav_links.length; i++) {
        if(cache.nav_links[i].href.indexOf("#") != -1){
          cache.nav_links[i].addEventListener("click", scrollToNav);
        }
      }
    };

    let scrollToNextSection = function() {
      const el = this;
      const section = el.closest('section').nextElementSibling;
      anime({
        targets: globalVar.scrollElement,
        scrollTop: (section.offsetTop-80),
        duration: 600,
        easing: 'easeOutQuad'
      });
    };

    let scrollToSection = function() {
      const el = this;
      const section = document.querySelector(el.getAttribute("href"));
      anime({
        targets: globalVar.scrollElement,
        scrollTop: (section.offsetTop-80),
        duration: 600,
        easing: 'easeOutQuad'
      });
    };

    let scrollToNav = function(e) {
      const href = this.href;
      const strings = href.split('#');
      if(strings[0] === window.location.href.split('#')[0]) {
        e.preventDefault();
        const section = document.querySelector('#'+strings[1]);
        anime({
          targets: globalVar.scrollElement,
          scrollTop: (section.offsetTop-80),
          duration: 600,
          easing: 'easeOutQuad'
        });
      }
    };

    let openNav = () => {
      cache.navmobileBtn.removeEventListener("click", openNav);
      cache.nav.style.display="flex";
      document.querySelector('body').classList.add('overflow');
      document.querySelector('html').classList.add('overflow');
      anime({
        targets: cache.navmobileBtn.querySelector('.burger'),
        opacity: [1,0],
        duration: 300,
        easing: 'easeOutSine'
      });
      anime({
        targets: cache.navmobileBtn.querySelector('.close'),
        opacity: [0,1],
        delay: 200,
        duration: 300,
        easing: 'easeOutSine'
      });
      anime({
        targets: cache.nav,
        opacity: [0,1],
        translateX: [250,0],
        duration: 600,
        easing: 'easeOutSine',
        complete: function() {
          cache.navmobileBtn.addEventListener("click", closeNav);
        }
      });
    }

    let closeNav = () => {
      cache.navmobileBtn.removeEventListener("click", closeNav);
      document.querySelector('body').classList.remove('overflow');
      document.querySelector('html').classList.remove('overflow');
      anime({
        targets: cache.navmobileBtn.querySelector('.burger'),
        opacity: [0,1],
        duration: 400,
        easing: 'easeOutSine'
      });
      anime({
        targets: cache.navmobileBtn.querySelector('.close'),
        opacity: [1,0],
        duration: 400,
        easing: 'easeOutSine'
      });
      anime({
        targets: cache.nav,
        opacity: [1,0],
        translateX: [0,250],
        duration: 400,
        easing: 'easeOutSine',
        complete: function() {
          cache.navmobileBtn.addEventListener("click", openNav);
          cache.nav.style.display="none";
        }
      });
    }

    let closeAlert = () => {
      anime({
        targets: cache.alert,
        height: 0,
        duration: 500,
        easing: 'easeOutSine',
        complete:  function() {
          cache.alert.style.display = "none";
        }
      });
      anime({
        targets: document.body,
        paddingTop: 0,
        duration: 500,
        easing: 'easeOutSine'
      });
    }

    initFunc();
  };
}
export { Nav }
